import React from "react"
import { useLocation } from "react-router-dom"
import { Helmet } from "react-helmet-async"
import { Container } from "reactstrap"
import OverviewComponent from "components/Overview"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { OVERVIEW } from "constants/entitlements"

const Overview = () => {
  const location = useLocation()

  const pathParts = location.pathname.split("/")
  const projectId = pathParts[2] || ""

  return (
    <EntitlementPageGuard permission={OVERVIEW}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Resumen </title>
        </Helmet>
        <Container fluid>
          <OverviewComponent projectId={projectId} />
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default Overview
